export const getServicesUrl = () => '/llm_services';

export const getTtsServicesUrl = () => '/llm_services/tts';

export const getSttServicesUrl = () => '/llm_services/stt';

export const getLlmServicesUrl = () => '/llm_services/llm';
